/** @file yawZero: where the key's yaw 0 lies on the gizmo's Z (yaw) ring, as a ring parameter in radians. */
import { quatRotateVec3 } from '@zilo/pose3d-math/quat/quatRotateVec3';
import type { Vec3 } from '@zilo/pose3d-math/vec3/vec3';
import type { TransformSpace } from '../../state/editorTypes';
import type { GizmoModel } from './gizmoModel';
import { parentRotation } from './parentRotation';
import type { PreviewPuppet } from './previewPuppet';

const SOUTH: Vec3 = [0, -1, 0];

/**
 * Yaw 0 faces south (design: yaw clockwise from south). `world`: the world south; `local`: the south of the frame the
 * key is written in (the parent's rotation, `parentRotation`), so the tick follows the parent. The direction is taken
 * into the ring's plane (`cos t X + sin t Y` of the gizmo axes): `t = atan2(d . Y, d . X)`; -pi/2 for world axes.
 */
export function yawZero(model: GizmoModel, space: TransformSpace, puppet: PreviewPuppet | null): number {
  const state = puppet?.instance.state();
  const d = space === 'local' && state !== undefined ? quatRotateVec3(parentRotation(state.pose, model.active, state.facingDeg), SOUTH) : SOUTH;
  const [x, y] = [model.axes[0], model.axes[1]];
  return Math.atan2(d[0] * y[0] + d[1] * y[1] + d[2] * y[2], d[0] * x[0] + d[1] * x[1] + d[2] * x[2]);
}
